import { SpinnerIcon } from 'public/svg/IconsSvg';

export const LoadingOverlay: FC = ({ className }) => {
    return (
        <div className="absolute inset-0 z-overlay flex h-full w-full items-center justify-center bg-grayMidDarker opacity-50">
            <SpinnerIcon className={className} />
        </div>
    );
};
